export const initialState = {
  smsFilters:{
    phoneNumber: "",
    beginDate: "",
    endDate: "",
    messageType:"",
    take: 10,
    skip: 1,
   },
   mailFilters:{
    customerMail: "",
    beginDate: "",
    endDate: "",
    take: 10,
    skip: 1,
   }
  }